import { Box, Button, CircularProgress, Stack, Typography } from '@mui/material'
import { Suspense, useEffect } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { useTranslation } from 'react-i18next'
import { BrowserRouter, Route, Routes } from 'react-router-dom'

import { DevicesProvider } from './components/Devices/Contexts/DevicesContext.jsx'
import MainLayout from './components/Layout/MainLayout.jsx'
import ProtectedRoutes from './components/Layout/ProtectedRoute/ProtectedRoute.jsx'
import FrontPageTemplate from './components/Layout/Templates/FrontPage.jsx'
import NoMatch from './components/Layout/Templates/NoMatch.jsx'
import ResetPasswordTemplate from './components/Layout/Templates/ResetPassword.jsx'
import InlineMessage from './components/Shared/Components/InlineMessage.jsx'
import { TestsProvider } from './components/Tests/Contexts/TestsContext.jsx'
import SelectTestType from './components/Tests/Pages/SelectTestType.jsx'
import TestGatewaySteps from './components/Tests/Pages/TestGatewaySteps.jsx'
import TestSiteSteps from './components/Tests/Pages/TestSiteSteps.jsx'
import VerifyGateway from './components/Tests/Pages/VerifyGateway.jsx'
import { UsersProvider } from './components/Users/Contexts/UsersContext.jsx'

const App = () => {
  const { i18n } = useTranslation()

  useEffect(() => {
    document.documentElement.lang = i18n.language
  }, [i18n.language])

  return (
    <Suspense
      fallback={
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          minHeight="100vh">
          <CircularProgress />
          <Box>
            <Typography>Loading ...</Typography>
          </Box>
        </Box>
      }>
      <ErrorBoundary
        onError={(e) => {
          console.log('ERRORE', e)
        }}
        fallback={
          <Stack
            alignContent={'center'}
            alignItems={'center'}>
            <InlineMessage message={'Ops!!!Something went wrong!!!'} />
            <Button
              size="small"
              sx={{ height: '38px' }}
              component="label"
              variant="contained"
              onClick={() => (window.location.href = '/')}>
              Click to reload the page
            </Button>
          </Stack>
        }>
        <BrowserRouter>
          <Routes>
            <Route
              path="/"
              element={<MainLayout />}>
              <Route
                index
                element={
                  <FrontPageTemplate />
                }
              />
              <Route
                path="*"
                element={<NoMatch />}
              />
            </Route>

            <Route
              path="/password-reset"
              element={<MainLayout />}>
              <Route
                path=":requestId"
                element={<ResetPasswordTemplate />}
              />
            </Route>

            <Route element={<ProtectedRoutes />}>
              <Route
                path="/select-test"
                element={<MainLayout />}>
                <Route
                  index
                  element={
                    <SelectTestType />
                  }
                />
              </Route>

              <Route
                path="/verify-gateway"
                element={<MainLayout />}>
                <Route
                  index
                  element={
                    <VerifyGateway />
                  }
                />
              </Route>

              <Route
                path="/test-gateway"
                element={<MainLayout />}>
                <Route
                  index
                  element={
                    <TestsProvider>
                      <UsersProvider>
                        <TestGatewaySteps />
                      </UsersProvider>
                    </TestsProvider>
                  }
                />
              </Route>

              <Route
                path="/test-site"
                element={<MainLayout />}>
                <Route
                  index
                  element={
                    <TestsProvider>
                      <UsersProvider>
                        <DevicesProvider>
                          <TestSiteSteps />
                        </DevicesProvider>
                      </UsersProvider>
                    </TestsProvider>
                  }
                />
              </Route>

            </Route>
          </Routes>
        </BrowserRouter>
      </ErrorBoundary>
    </Suspense>
  )
}

export default App
